/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IPermitToWorkLocationType } from '../models/permit-to-work-location-type.model';

export class LoadPermitToWorkLocationTypes {
  static readonly type = '[Permit To Work Location Type] Load';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllPermitToWorkLocationTypes {
  static readonly type = '[Permit To Work Location Type] Load All';
}

export class CreatePermitToWorkLocationType {
  static readonly type = '[Permit To Work Location Type] Create';
  constructor(public locationType: IPermitToWorkLocationType) {}
}

export class UpdatePermitToWorkLocationType {
  static readonly type = '[Permit To Work Location Type] Update';
  constructor(public locationType: IPermitToWorkLocationType) {}
}
